import { render, staticRenderFns } from "./RoleCreate.vue?vue&type=template&id=17fd636a&"
import script from "./RoleCreate.js?vue&type=script&lang=js&"
export * from "./RoleCreate.js?vue&type=script&lang=js&"
import style0 from "./RoleCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports